import { useQuery } from "@tanstack/react-query";
import { ApiGetCustodyConfig } from "@/api";
import type { GetCustodyConfigResponse } from "@/api/types";

export const useGetCustodyConfig = () => {
  return useQuery({
    queryKey: ["custodyConfig"],
    queryFn: async (): Promise<GetCustodyConfigResponse> => {
      const res = await ApiGetCustodyConfig();
      return res.data;
    },
  });
};
